/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error400CodeEnum,
    Error401CodeEnum,
    Error403CodeEnum,
    Error404CodeEnum,
    Error500CodeEnum,
    Error504CodeEnum,
} from 'client-code/iptv-login';
import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { ErrorTypes } from './ErrorTypes';
import { SignInError } from './SignInError';

export class IptvLoginError extends SignInError {
    TAG: string = 'IptvLoginError';

    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.message = message;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case Error400CodeEnum.AuthsBadRequest:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_BAD_REQUEST_C601;
                this.type = Error400CodeEnum.AuthsBadRequest;
                break;
            case Error401CodeEnum.AuthsExpiredSamlToken:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_EXPIRED_SAML_TOKEN_C602;
                this.type = Error401CodeEnum.AuthsExpiredSamlToken;
                break;
            case Error401CodeEnum.AuthsInvalidSamlToken:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_INVALID_SAML_TOKEN_C605;
                this.type = Error401CodeEnum.AuthsInvalidSamlToken;
                break;
            case Error403CodeEnum.AuthsNotAuthorized:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_NOT_AUTHORIZED_C606;
                this.title = Locale.getString(LocaleKeys.SIGN_IN_ERROR_ACCOUNT_LOCKED_TITLE);
                this.type = Error403CodeEnum.AuthsNotAuthorized;
                break;
            case Error403CodeEnum.AuthsTooManyDevices:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_TOO_MANY_DEVICES_C608;
                this.title = Locale.getString(LocaleKeys.SIGN_IN_ERROR_TOO_MANY_DEVICES_TITLE);
                this.type = Error403CodeEnum.AuthsTooManyDevices;
                break;
            case Error404CodeEnum.AuthsResourceNotFound:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_RESOURCE_NOT_FOUND_C607;
                this.type = Error404CodeEnum.AuthsResourceNotFound;
                break;
            case Error500CodeEnum.AuthsInternalServerError:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_INTERNAL_SERVER_ERROR_C604;
                this.type = Error500CodeEnum.AuthsInternalServerError;
                break;
            case Error504CodeEnum.AuthsIntegrationTimeout:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_INTEGRATION_TIMEOUT_C603;
                this.type = Error504CodeEnum.AuthsIntegrationTimeout;
                break;

            default:
                this.code = ErrorTypes.SIGN_IN_IPTV_LOGIN_UNKNOWN_ERROR_C699;
                this.type = 'IPTV_LOGIN_UNKNOWN_ERROR';
        }
    }
}
